<div class="modal-header">
    <h4 class="modal-title">{{ isNew ? 'Add Allowed Supplier' : 'Edit Allowed Supplier' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (errorMessage) {
        <div class="alert alert-danger py-1 px-2 mb-2">{{ errorMessage }}</div>
    }
    <form #supplierForm="ngForm">
        <!-- Supplier ID -->
        <div class="form-group row mb5">
            <label for="supplierId" class="col-sm-3 col-form-label">Supplier ID <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="supplierId" name="supplierId"
                    [(ngModel)]="model.supplierId" [readonly]="!isNew" required>
            </div>
        </div>

        <!-- Supplier Name -->
        <div class="form-group row mb5">
            <label for="supplierName" class="col-sm-3 col-form-label">Supplier Name</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="supplierName" name="supplierName"
                    [(ngModel)]="model.supplierName">
            </div>
        </div>

        <!-- Default Currency Code -->
        <div class="form-group row mb5">
            <label for="defaultCurrencyCode" class="col-sm-3 col-form-label">Currency Code</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="defaultCurrencyCode" name="defaultCurrencyCode"
                    [(ngModel)]="model.defaultCurrencyCode">
            </div>
        </div>

        <!-- Is Active -->
        <div class="form-group row mb5">
            <label for="isActive" class="col-sm-3 col-form-label">Active</label>
            <div class="col-sm-9 d-flex align-items-center">
                <input type="checkbox" class="form-check-input" id="isActive" name="isActive"
                    [(ngModel)]="model.isActive">
            </div>
        </div>

        <!-- Business Contact Email -->
        <div class="form-group row mb5">
            <label for="businessContactEmail" class="col-sm-3 col-form-label">Business Contact Email</label>
            <div class="col-sm-9">
                <input type="email" class="form-control" id="businessContactEmail" name="businessContactEmail"
                    [(ngModel)]="model.businessContactEmail">
            </div>
        </div>

        <!-- Technical Contact Email -->
        <div class="form-group row mb5">
            <label for="technicalContactEmail" class="col-sm-3 col-form-label">Technical Contact Email</label>
            <div class="col-sm-9">
                <input type="email" class="form-control" id="technicalContactEmail" name="technicalContactEmail"
                    [(ngModel)]="model.technicalContactEmail">
            </div>
        </div>

        <!-- ServiceNow Group -->
        <div class="form-group row mb5">
            <label for="serviceNowGroup" class="col-sm-3 col-form-label">ServiceNow Group</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="serviceNowGroup" name="serviceNowGroup"
                    [(ngModel)]="model.serviceNowGroup">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()"
        [disabled]="isSaving || !supplierForm.valid">
        @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Save
    </button>
</div>
